import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {
  reportDate: any = "";
  dateRange: any[] =[];


  constructor() { 
    this.reportDate = new Date;
    this.dateRange.push(new Date);
    this.dateRange.push(new Date);
  }
}
